import React from 'react';
import { Link } from 'react-router-dom';
import Header from 'src/layouts/Header';
import Footer from 'src/layouts/Footer';
import useSEO from 'src/hooks/useSEO';

const NotFound = () => {
  useSEO({
    title: '404 | SphynxPlace.com',
    description: 'The page you are looking for could not be found.',
    robots: 'noindex, follow',
  });
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <div className="bg-[#F7F7F7] flex-1 flex items-center justify-center py-4">
        <div className="container mx-auto px-4 w-full flex justify-center">
          <div className="max-w-[600px] w-full text-center">
            {/* 404 Number */}
            <h1 className="text-[80px] md:text-[120px] font-extrabold text-[#832EE6] mb-4 leading-none">
              404
            </h1>
            
            {/* Title */}
            <h2 className="text-[24px] md:text-[32px] font-bold text-[#0D0D0D] mb-4">
              Page Not Found
            </h2>
            
            {/* Description */}
            <p className="text-gray-600 mb-8 text-sm md:text-base leading-relaxed">
              Sorry, we can't find the page you're looking for. The page might have been moved, deleted, or the URL might be incorrect.
            </p>

            {/* Icon */}
            <div className="flex justify-center mb-8">
              <svg className="w-24 h-24 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>

            {/* Action buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/"
                className="inline-flex items-center justify-center bg-[#832EE6] text-white font-bold py-3 px-6 rounded-full hover:bg-[#6f26c4] transition-colors text-base md:text-lg"
              >
                Go to Homepage
              </Link>
              <button
                onClick={() => window.history.back()}
                className="inline-flex items-center justify-center border-2 border-[#832EE6] text-[#832EE6] font-bold py-3 px-6 rounded-full hover:bg-[#832EE6] hover:text-white transition-colors text-base md:text-lg"
              >
                Go Back
              </button>
            </div>

            {/* Helpful links */}
            <div className="mt-8 pt-8 border-t border-gray-300">
              <p className="text-sm text-gray-600 mb-4">You might be looking for:</p>
              <div className="flex flex-wrap justify-center gap-4">
                <Link to="/search" className="text-[#832EE6] hover:text-[#6f26c4] font-semibold text-sm transition-colors">
                  Search Ads
                </Link>
                <Link to="/blog" className="text-[#832EE6] hover:text-[#6f26c4] font-semibold text-sm transition-colors">
                  Blog
                </Link>
                <Link to="/contact" className="text-[#832EE6] hover:text-[#6f26c4] font-semibold text-sm transition-colors">
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;